import { gql } from '@apollo/client';

export const UPDATE_RATES = gql`
  mutation UpdateRates {
    updateRates
  }
`;
